import { render } from "./Mb027.vue?vue&type=template&id=469d3c15"
import script from "./Mb027.vue?vue&type=script&lang=js"
export * from "./Mb027.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__